@if (workerRegistrations && workerRegistrations.length) {

@if(!option.multiplePhases){
<!-- <tr><td colspan="3"><b>Dipendenti</b></td></tr> -->

  @for (item of workerRegistrations; track item) {
    @if( item.phaseCode == currentPhaseCode){
<tr>
  <td></td>
  <td>{{item.workerDescription}}</td>
  <td align="right">{{item.oreLavorate}}</td>
</tr>
    }
  }
}


@if(option.multiplePhases){
<!-- <tr><td colspan="3"><b>Dipendenti</b></td></tr> -->
  @for (item of displayWorkerRegistrations; track item) {
    @if( item.phaseCode == currentPhaseCode){
<tr>

  <td>{{item.workerDescription}} - {{item.costDescription}}</td>
  <td align="right">{{item.oreLavorate}} </td>
  <td></td>
</tr>
    }
  }
}

}
